import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { ChatCopyListComponent } from '@commons/chat-assistance/chat-copy-list/chat-copy-list.component';
import { module } from 'angular';

import { ChatAssistanceService } from './chat-assistance.service';
import { ChatListComponent } from './chat-list/chat-list.component';
import { ChatRoomComponent } from './chat-room/chat-room.component';
import { ChatWindowComponent } from './chat-window/chat-window.component';

export default module('contact.commons.chat', [])
  .factory('chat-assistance', downgradeInjectable(ChatAssistanceService as any))
  .directive('chatCopyList', downgradeComponent({ component: ChatCopyListComponent }) as angular.IDirectiveFactory)
  .directive('chatList', downgradeComponent({ component: ChatListComponent }) as angular.IDirectiveFactory)
  .directive('chatRoom', downgradeComponent({ component: ChatRoomComponent }) as angular.IDirectiveFactory)
  .directive('chatWindow', downgradeComponent({ component: ChatWindowComponent }) as angular.IDirectiveFactory).name;
